<template>
    <section id="recommended-offers">
        <EligibilityResult
            v-if="showEligibilityResult && recommendedOffersData.eligibilityResult"
            :eligibility-result="recommendedOffersData.eligibilityResult"
        />
        <div class="container-fluid mb-2 mb-md-3">
            <div class="row px-1">
                <div class="col-12 px-0">
                    <div class="container mw-100">
                        <div class="row px-0">
                            <div class="col-12 col-lg-8 px-0 pe-lg-1">
                                <swiper-container
                                    uniq-swiper-id="recommendedOffersSwiper1"
                                    :pagination="swiperPagination"
                                    :padding-bottom-in-px="swiperPaddingBottomInPx"
                                    :slides-per-view="swiperSlidesPerView"
                                    :space-between="swiperSpaceBetween"
                                    :navigation="swiperNavigation"
                                    :breakpoints="swiperBreakpoints"
                                >
                                    <swiper-slide>
                                        <RecommendedMobileOfferTile
                                            :key="recommendedMobileOfferWithUpdatedFoLink.seoId"
                                            :offer="recommendedMobileOfferWithUpdatedFoLink"
                                        />
                                    </swiper-slide>
                                    <swiper-slide>
                                        <RecommendedInternetOfferTile
                                            :key="recommendedInternetOfferWithUpdatedFoLink.seoId"
                                            :offer="recommendedInternetOfferWithUpdatedFoLink"
                                            :icon-plus="recommendedOffersData.iconPlus"
                                        />
                                    </swiper-slide>
                                </swiper-container>
                            </div>
                            <div class="col-12 col-lg-4 px-0 ps-lg-1">
                                <RecommendedOfferRecapTile
                                    :eligibility-result="recommendedOffersData.eligibilityResult"
                                    :icon-equal="recommendedOffersData.iconEqual"
                                    :internet-offer="recommendedInternetOfferWithUpdatedFoLink"
                                    :mobile-offer="recommendedMobileOffer"
                                    :offers-total-price-label="recommendedOffersData.offersTotalPriceLabel"
                                    :generic-button-cta="recommendedOffersData.packSummary.genericButtonCta"
                                    :total-price="totalPrice"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!recommendedOffersData.eligibilityResult" class="col-12 px-0 pt-1">
                    <a
                        :href="recommendedOffersData.alternateLink.link"
                        :data-oevent-category="recommendedOffersData.alternateLink.tms.category"
                        :data-oevent-action="recommendedOffersData.alternateLink.tms.action"
                        :data-oevent-label="recommendedOffersData.alternateLink.tms.label"
                        class="ob1-link-arrow ob1-link-large"
                        v-html="recommendedOffersData.alternateLink.label"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import RecommendedInternetOfferTile from "./RecommendedInternetOfferTile";
import RecommendedMobileOfferTile from "./RecommendedMobileOfferTile";
import RecommendedOfferRecapTile from "./RecommendedOfferRecapTile";
import EligibilityResult from "./eligibility/EligibilityResult";
import SwiperSlide from "../../../../../../common/components/vue/swiper/SwiperSlide.vue";
import SwiperContainer from "../../../../../../common/components/vue/swiper/SwiperContainer.vue";

export default {
    name: "RecommendedOffers",
    components: {
        SwiperContainer,
        SwiperSlide,
        EligibilityResult,
        RecommendedInternetOfferTile,
        RecommendedMobileOfferTile,
        RecommendedOfferRecapTile
    },
    props: {
        internetOffersModel: {type: Array, required: true},
        mobileOffersModel: {type: Array, required: true},
        mobileOffersTiles: {type: Array, required: true},
        internetOffersTiles: {type: Array, required: true},
        recommendedOffersData: {type: Object, required: true},
        showEligibilityResult: {type: Boolean, required: false, default: true},
        foLinkQueryParams: {type: Object, required: false, default: undefined},
    },
    data() {
        return {
            swiperSlidesPerView: 1.2,
            swiperPagination: false,
            swiperPaddingBottomInPx: 0,
            swiperSpaceBetween: 30,
            swiperNavigation: false,
            swiperBreakpoints: {
                // when window width is <= 560px
                560: {
                    slidesPerView: 1.4
                },
                // when window width is <= 662px
                662: {
                    slidesPerView: 1.8
                },
                // when window width is <= 736px
                736: {
                    slidesPerView: 2
                }
            },
        }
    },
    computed: {
        totalPrice() {
            return this.recommendedOffersData.packSummary.totalPrice
        },
        recommendedInternetOffer() {
            return this.internetOffersTiles.find(tile => tile.seoId === this.internetOffersModel.find(model => model.highlighted === true).seoId)
        },
        recommendedMobileOffer() {
            return this.mobileOffersTiles.find(tile => tile.seoId === this.mobileOffersModel.find(model => model.highlighted === true).seoId)
        },
        recommendedInternetOfferWithUpdatedFoLink() {
            if (this.foLinkQueryParams) {
                const updatedFoLink = new URL(this.recommendedInternetOffer.foLink);

                updatedFoLink.searchParams.set('offreInternet', this.foLinkQueryParams.offreInternet);
                updatedFoLink.searchParams.set('offreMobile', this.foLinkQueryParams.offreMobile);
                updatedFoLink.searchParams.set('vitrineHashTag', this.foLinkQueryParams.vitrineHashTag);

                return { ...this.recommendedInternetOffer, foLink: updatedFoLink.toString() };
            }
            return this.recommendedInternetOffer;
        },
        recommendedMobileOfferWithUpdatedFoLink() {
            if (this.foLinkQueryParams) {
                const updatedFoLink = new URL(this.recommendedMobileOffer.foLink);

                updatedFoLink.searchParams.set('offreInternet', this.foLinkQueryParams.offreInternet);
                updatedFoLink.searchParams.set('offreMobile', this.foLinkQueryParams.offreMobile);
                updatedFoLink.searchParams.set('vitrineHashTag', this.foLinkQueryParams.vitrineHashTag);
                // without queryParam technology update

                return { ...this.recommendedMobileOffer, foLink: updatedFoLink.toString() }
            }
            return this.recommendedMobileOffer
        },
    }
}
</script>

<style scoped lang="scss">

// hack hauteur tuiles noires EDITO
.swiper-slide-height {
    height: auto !important;
}

</style>
